import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SECTIONS } from '../shared/section';

@Component({
  selector: 'lumiron-about',
  templateUrl: './about.component.html',
  styleUrl: './about.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, SECTIONS],
})
export class AboutComponent {}
